import React from 'react';
import { Button, Tooltip } from 'antd';
import { BellOutlined } from '@ant-design/icons';

export default function AlertSilenceIconButton({
  isSilenced = false,
  onClick,
  disabled = false,
}) {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled) onClick?.(e);
  };

  return (
    <Tooltip title={isSilenced ? 'Silenced — click to unsilence' : 'Silence alert'}>
      <Button
        type="text"
        size="small"
        aria-pressed={isSilenced}
        className="alert-rule-silence-icon-btn"
        icon={
          <span
            className={
              isSilenced
                ? 'alert-silence-bell alert-silence-bell--struck'
                : 'alert-silence-bell'
            }
          >
            <BellOutlined />
          </span>
        }
        onClick={handleClick}
        disabled={disabled}
      />
    </Tooltip>
  );
}
